<template>
  <v-container class="pa-5">
    <v-tabs
      grow>
      <v-tabs-slider color="k-orange-linear" />
      <v-tab ripple>
        Arbol de gestión
      </v-tab>
      <v-tab ripple>
        Arbol de compromisos
      </v-tab>
      <v-tab-item>
        <workflow-tree
          :workflow="workflow"
          :stages="stages"
          @stage-created="stageCreated"
          @stage-updated="stageUpdated"
          @stage-deleted="stageDeleted"
          @filter-created="filterCreated"
          @filter-updated="filterUpdated"
          @filter-deleted="filterDeleted"/>
      </v-tab-item>
      <v-tab-item>
        <payment-promise-tree
          :workflow="workflow"
          :p-stages="pStages"
          @p-stage-created="pStageCreated"
          @p-stage-updated="pStageUpdated"
          @p-stage-deleted="pStageDeleted"
          @p-filter-created="pFilterCreated"
          @p-filter-updated="pFilterUpdated"
          @p-filter-deleted="pFilterDeleted"/>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import Vue from 'vue';
import _ from 'lodash';
import WorkflowTree from '@/components/CollectWorkflows/Detail/WorkflowTree/Index';
import PaymentPromiseTree from '@/components/CollectWorkflows/Detail/PaymentPromiseTree/Index';
import filtersMixin from '@/mixins/workflowFilters';

export default {
  components: {
    WorkflowTree,
    PaymentPromiseTree,
  },
  beforeRouteEnter(to, from, next) {
    const workflowId = to.params.workflow;
    Promise.all([
      Vue.axios.get(`workflows/${workflowId}`),
      Vue.axios.get(`workflows/${workflowId}/stages`),
      Vue.axios.get(`workflows/${workflowId}/payment_p_stages`),
      filtersMixin.methods.findFilters(),
    ]).then((values) => {
      next((vm) => {
        vm.workflow = values[0].data; // eslint-disable-line
        vm.stages = values[1].data; // eslint-disable-line
        vm.pStages = values[2].data; // eslint-disable-line
        vm.sortStages();
      });
    }).catch(() => {});
  },
  mixins: [
    filtersMixin,
  ],
  data() {
    return {
      workflow: {},
      stages: [],
      pStages: [],
    };
  },
  methods: {
    sortStages() {
      // eslint-disable-next-line
      this.stages = _.sortBy(this.stages, item => parseInt(item.delinquency_start, 10) + parseInt(item.delinquency_end, 10));
    },
    stageCreated(stage) {
      this.stages.push(stage);
      this.sortStages();
    },
    stageUpdated(selectedStage) {
      const index = this.stages.findIndex(item => item.id === selectedStage.id);
      const stage = {
        ...this.stages[index],
        ...selectedStage,
      };
      if (this.stages[index].status === 'Activo' && stage.status === 'Inactivo') {
        for (let i = 0; i < stage.filters.length; i += 1) {
          stage.filters[i].status = 'Inactivo';
        }
      }
      this.$set(this.stages, index, stage);
      this.sortStages();
    },
    stageDeleted(selectedStage) {
      const index = this.stages.findIndex(item => item.id === selectedStage.id);
      this.stages.splice(index, 1);
      this.sortStages();
    },
    filterCreated(selectedStage, filter) {
      const stage = {
        ...selectedStage,
      };
      if (filter.order === stage.filters.length) {
        stage.filters.push(filter);
      } else {
        stage.filters.splice(filter.order - 1, 0, filter);
      }
      for (let i = 1; i <= stage.filters.length; i += 1) {
        stage.filters[i - 1].order = i;
      }
      stage.filters = _.sortBy(stage.filters, item => item.order);
      const index = this.stages.findIndex(item => item.id === stage.id);
      this.$set(this.stages, index, stage);
    },
    filterUpdated(selectedStage, filter) {
      const stage = {
        ...selectedStage,
      };
      const index = stage.filters.findIndex(item => item.id === filter.id);
      const currentOrder = stage.filters[index].order;
      const newOrder = filter.order;
      if (newOrder < currentOrder) {
        for (let i = newOrder; i < currentOrder; i += 1) {
          const index2 = stage.filters.findIndex(item => item.order === i);
          stage.filters[index2].order = i + 1;
        }
      } else if (newOrder > currentOrder) {
        for (let i = currentOrder + 1; i <= newOrder; i += 1) {
          const index2 = stage.filters.findIndex(item => item.order === i);
          stage.filters[index2].order = i - 1;
        }
      }
      stage.filters[index] = filter;
      stage.filters = _.sortBy(stage.filters, item => item.order);
      this.stageUpdated(stage);
    },
    filterDeleted(selectedStage, selectedFilter) {
      const stage = {
        ...selectedStage,
      };
      const index = stage.filters.findIndex(item => item.id === selectedFilter.id);
      stage.filters.splice(index, 1);
      for (let i = 1; i <= stage.filters.length; i += 1) {
        stage.filters[i - 1].order = i;
      }
      stage.filters = _.sortBy(stage.filters, item => item.order);
      this.stageUpdated(stage);
    },
    sortPStages() {
      this.pStages = _.sortBy(this.pStages, item => parseInt(item.days_off, 10));
    },
    pStageCreated(pStage) {
      this.pStages.push(pStage);
      this.sortPStages();
    },
    pStageUpdated(selectedPStage) {
      const index = this.pStages.findIndex(item => item.id === selectedPStage.id);
      const pStage = {
        ...this.pStages[index],
        ...selectedPStage,
      };
      if (this.pStages[index].status === 1 && pStage.status === 0) {
        for (let i = 0; i < pStage.filters.length; i += 1) {
          pStage.filters[i].status = 0;
        }
      }
      this.$set(this.pStages, index, pStage);
      this.sortPStages();
    },
    pStageDeleted(selectedPStage) {
      const index = this.pStages.findIndex(item => item.id === selectedPStage.id);
      this.pStages.splice(index, 1);
      this.sortPStages();
    },
    pFilterCreated(selectedPStage, pFilter) {
      const stage = {
        ...selectedPStage,
      };
      stage.filters.push(pFilter);
      const index = this.stages.findIndex(item => item.id === stage.id);
      this.$set(this.stages, index, stage);
    },
    pFilterUpdated(selectedPStage, pFilter) {
      const pStage = {
        ...selectedPStage,
      };
      const index = pStage.filters.findIndex(item => item.id === pFilter.id);
      pStage.filters[index] = pFilter;
      this.pStageUpdated(pStage);
    },
    pFilterDeleted(selectedPStage, pFilter) {
      const pStage = {
        ...selectedPStage,
      };
      const index = pStage.filters.findIndex(item => item.id === pFilter.id);
      pStage.filters.splice(index, 1);
      this.stageUpdated(pStage);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/CollectWorkflows/Detail/Index.vue